import React, { useState } from "react";
import { ManageLookup } from "../manageLookup";
import { GenericModal, initialModalState, onCancel, onSave, onShow, } from "./GenericModal";
var noop = function () {
    //np
};
export var showPicker = noop;
export var ModalPicker = function () {
    var _a = useState("Lookup"), lookupTitle = _a[0], setLookupTitle = _a[1];
    var _b = useState(initialModalState), isLookup = _b[0], setIsLookup = _b[1];
    var _c = useState({
        formKey: "",
        endpoint: "",
    }), lookupInfo = _c[0], setLookupInfo = _c[1];
    showPicker = function (data) {
        onShow(setIsLookup);
        setLookupInfo(data);
        setLookupTitle(data.tableLabel);
    };
    return (React.createElement(GenericModal, { show: isLookup.show, title: lookupTitle, hideFooter: true, cancel: function () { return onCancel(setIsLookup); }, save: function () { return onSave(setIsLookup); } },
        React.createElement(ManageLookup, { cancel: function () { return onCancel(setIsLookup); }, lookupInfo: lookupInfo })));
};
//# sourceMappingURL=ModalPicker.js.map